const generateTelemetryKey = (prefix) => (key) => `${prefix}.${key}`;

export { generateTelemetryKey };
//# sourceMappingURL=generateTelemetryKey.mjs.map
